import request from "../../utils/request";

export const requestGetInfo = (params) => {
  return request({ method: "GET", path: "/admin-management/getUserInfo", params });
};

export const logout = (params) => {
  return request({ method: "POST", path: "/admin-management/logout", params });
};